/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authresolvefailedmessage3Inputs */



/**
* | output |
* | --- |
* | "Login error. Try restarting the app or hit us up — we'll fix it." |
*
* @param {Authresolvefailedmessage3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const authresolvefailedmessage3 = /** @type {((inputs?: Authresolvefailedmessage3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authresolvefailedmessage3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Login error. Try restarting the app or hit us up — we'll fix it.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al iniciar sesión. Prueba a reiniciar la app o escríbenos: lo arreglamos.")
	return /** @type {LocalizedString} */ ("Произошла ошибка при входе в аккаунт. Попробуй перезапустить приложение или напиши нам — разберёмся.")
});
export { authresolvefailedmessage3 as "authResolveFailedMessage" }